function ProductSlider(sectionId) {
  this.slider = null;
  this.sectionElement = document.querySelector(`#shopify-section-${sectionId}`);

  if (!this.sectionElement) {
    console.error(
      `Required elements not found for section with ID: ${sectionId}`
    );
    return;
  }

  this.init = function () {
    const prevSlide = this.sectionElement.querySelector(".prev-slide");
    const nextSlide = this.sectionElement.querySelector(".next-slide");
    const sliderWrapper = this.sectionElement.querySelector(".keen-slider");

    console.log("Initializing slider for section:", sectionId);

    this.slider = new KeenSlider(
      sliderWrapper,
      {
        loop: true,
        breakpoints: {
          "(min-width: 320px)": {
            slides: { perView: 1.25, spacing: 16 },
          },
          "(min-width: 768px)": {
            slides: { perView: 3, spacing: 16 },
          },
          "(min-width: 1024px)": {
            slides: { perView: 4, spacing: 16 },
          },
        },
        slides: { perView: 1.5, spacing: 16 },
      },
      [
        (slider) => {
          let timeout;
          let mouseOver = false;
          function clearNextTimeout() {
            clearTimeout(timeout);
          }
          function nextTimeout() {
            clearTimeout(timeout);
            if (mouseOver) return;
            timeout = setTimeout(() => {
              slider.next();
            }, 2500);
          }
          slider.on("created", () => {
            slider.container.addEventListener("mouseover", () => {
              mouseOver = true;
              clearNextTimeout();
            });
            slider.container.addEventListener("mouseout", () => {
              mouseOver = false;
              nextTimeout();
            });
            nextTimeout();
          });
          slider.on("dragStarted", clearNextTimeout);
          slider.on("animationEnded", nextTimeout);
          slider.on("updated", nextTimeout);
        },
      ]
    );

    prevSlide.addEventListener("click", () => this.slider.prev());
    nextSlide.addEventListener("click", () => this.slider.next());
  };

  this.destroy = function () {
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
      this.sectionElement = null;
    }
  };

  // Call the init function when creating a new instance
  this.init();
}
